import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { DrawerHeader } from "@/components/ui/drawer";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Step } from "./constants";
import Card from "@/components/custom/card";
import { useTranslation } from "react-i18next";
import Loading from "@/components/custom/loading";
import { useGetBudgetCategories } from "@/services/queries/budgets";
import { ExpenseFormValues } from "./";

const BudgetCategoryStep = ({
  form,
  setStep,
}: {
  form: UseFormReturn<ExpenseFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation();
  const { data: categoriesData, isPending } = useGetBudgetCategories(
    form.watch("budgetId") || ""
  );

  const categories = useMemo(() => {
    return categoriesData?.value || [];
  }, [categoriesData]);

  return (
    <div>
      <DrawerHeader
        title={t("title.budget_category")}
        leftButton={
          <button
            type="button"
            onClick={() => setStep(Step.INITAL)}
            className="w-6"
          >
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-6" />}
      />

      <p className="mx-auto max-w-[210px] text-center text-sm font-medium leading-[18px] text-[#98B2D3]">
        {t("description.budget_category")}
      </p>

      {isPending ? (
        <Loading className="mt-10" />
      ) : (
        <div className="mt-5 space-y-[15px]">
          {categories.length > 0 ? (
            categories.map((category) => (
              <Card
                data-testid={`expense-form-category-item-${category.id}`}
                onClick={() => {
                  form.setValue("budgetCategoryId", category.id);
                  setStep(Step.SUB_CATEGORIES);
                }}
                className="px-[15px] py-[14px]"
                key={category.id}
              >
                <div className="flex flex-col items-start justify-between gap-3">
                  <span className="text-[15px] font-medium leading-[18px] text-white">
                    {category.name}
                  </span>
                </div>
                <CaretRight color="#E3EDFC" size={18} />
              </Card>
            ))
          ) : (
            <div className="mx-auto my-2 mt-5 max-w-[200px] text-center text-[15px] text-white">
              {t("description.not_found_budget_category")}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BudgetCategoryStep;
